// extracted by mini-css-extract-plugin
export default {"layout":"AppStackLayout_layout__YL-PE","body":"AppStackLayout_body__niweu","tab":"AppStackLayout_tab__JlPCI","drawer":"AppStackLayout_drawer__B7vQe"};